import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-row" }
const _hoisted_2 = { class: "buttons" }

import TileCard from '@/components/util/TileCard.vue';
import { useUserStore } from '@/stores/user';
import { onMounted, reactive } from 'vue';
import UserManagementTable from '@/components/tables/UserManagementTable.vue';
import UserDetail from '@/components/user/UserDetail.vue';
import { UserItem } from '@/services/entities/UserItem';
import { useAzureStore } from '@/stores/azure';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserManagementView',
  setup(__props) {

const userStore = useUserStore();
const azureStore = useAzureStore();

const state = reactive({
    userDetail: null,
});

onMounted(async () => {
    await userStore.loadAll();
    await azureStore.loadGroupMembers();
    await userStore.loadTeamLeaders()
});

async function createUser(user: UserItem) {
    await userStore.create(user)
    showDetail(user.id);
}
async function updateUser(user: UserItem) {
    await userStore.update(user)
    showDetail(user.id);
}
async function deleteUserRate(id: string) {
    await userStore.deleteUserRate(id);
    showDetail(state.userDetail?.id);
}

function showDetail(id: string) {
    state.userDetail = null;
    setTimeout(() => { state.userDetail = userStore.getAll.find(a => a.id == id); }, 100);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("span", { class: "title" }, "User management")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TileCard, {
        id: "usr-mng",
        loaded: _unref(userStore).getAllLoaded
      }, {
        body: _withCtx(() => [
          _createVNode(UserManagementTable, {
            data: _unref(userStore).getAll,
            onDetail: _cache[0] || (_cache[0] = (a) => showDetail(a))
          }, null, 8, ["data"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "accent",
              onClick: _cache[1] || (_cache[1] = () => state.userDetail = { startDate: new Date() })
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("b", null, "+", -1),
              _createTextVNode(" Add user", -1)
            ]))])
          ])
        ]),
        _: 1
      }, 8, ["loaded"]),
      (state.userDetail)
        ? (_openBlock(), _createBlock(TileCard, {
            key: 0,
            id: "usr-detail",
            class: "usr-detail",
            loaded: _unref(userStore).getAllLoaded
          }, {
            body: _withCtx(() => [
              _createVNode(UserDetail, {
                user: state.userDetail,
                onCreate: createUser,
                onUpdate: updateUser,
                onDeleteUserRate: deleteUserRate
              }, null, 8, ["user"])
            ]),
            _: 1
          }, 8, ["loaded"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})